import React, { useEffect, useState } from "react";
import auth from "../../firebase.init";
import {
  useSendPasswordResetEmail,
  useSignInWithEmailAndPassword,
  useSignInWithGoogle,
} from "react-firebase-hooks/auth";
import { useForm } from "react-hook-form";
import Loading from "../Shared/Loading";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useToken from "../../hooks/useToken";
const Login = () => {
  const [email, setEmail] = useState('');
  console.log(email)
  const [signInWithGoogle, guser, gloading, gerror] = useSignInWithGoogle(auth);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [signInWithEmailAndPassword, user, loading, error] =
    useSignInWithEmailAndPassword(auth);
const [token] = useToken(user || guser)

  const [sendPasswordResetEmail, sending, resetError] = useSendPasswordResetEmail(auth); //self try

  let signInerrorMessage;
  const navigate = useNavigate();
  const location = useLocation();
  let from = location.state?.from?.pathname || "/";

  useEffect(() => {
    if (token) {
      // console.log(user || guser);
      navigate(from, { replace: true });
    }
  }, [token, from, navigate]);

  if (loading || gloading ||sending) {
    return <Loading />;
  }

  if (error || gerror || resetError) {
    signInerrorMessage = (
      <p className="text-red-500">
        <small>{error?.message || gerror?.message || resetError?.message}</small>
      </p>
    );
  }

  const onSubmit = (data) => {
    // console.log(data);
    signInWithEmailAndPassword(data.email, data.password);
  };
  const resetPassword = async (data) =>{
    console.log(data.email)
      // await sendPasswordResetEmail(event.email);
      // alert('Sent email');
  }
  return (
    <div className="flex h-screen justify-center items-center mt-11">
      <div className="card w-96 bg-base-100 shadow-xl">
        <div className="card-body">
          <h2 className="text-center text-2xl font-bold">Login</h2>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-control w-full max-w-xs">
              <label className="label">
                <span className="label-text">Email</span>
              </label>
              <input
                type="email"
                onBlur={(event)=>setEmail(event.target.value)}
                placeholder="email@gmail.com"
                className="input input-bordered w-full max-w-xs"
                {...register("email", {
                  required: {
                    value: true,
                    message: "Email is Required",
                  },
                  pattern: {
                    value: /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/,
                    message: "Provide a valid Email",
                  },
                })}
              />
              <label className="label">
                {errors.email?.type === "required" && (
                  <span className="label-text-alt text-red-500">
                    {errors.email.message}
                  </span>
                )}
                {errors.email?.type === "pattern" && (
                  <span className="label-text-alt text-red-500">
                    {errors.email.message}
                  </span>
                )}
              </label>
            </div>

            <div className="form-control w-full max-w-xs">
              <label className="label">
                <span className="label-text">Password</span>
              </label>
              <input
                type="password"
                placeholder="type your password"
                className="input input-bordered w-full max-w-xs"
                {...register("password", {
                  required: {
                    value: true,
                    message: "Password is Required",
                  },
                  minLength: {
                    value: 6,
                    message: "Must be 6 characters or longer",
                  },
                })}
              />
              <label className="label">
                {errors.password?.type === "required" && (
                  <span className="label-text-alt text-red-500">
                    {errors.password.message}
                  </span>
                )}
                {errors.password?.type === "minLength" && (
                  <span className="label-text-alt text-red-500">
                    {errors.password.message}
                  </span>
                )}
              </label>
            </div>
            {signInerrorMessage}
            <input
              className="btn w-full max-w-xs text-white"
              type="submit"
              value="Login"
            />
              {/* <small> <button type="submit"  onClick={resetPassword}>Reset Password</button> </small> */}
          </form>
          <p>
            <small>
              New to Doctor's Portal{" "}
              <Link className="text-primary " to="/signup">
                Create new account?
              </Link>
            </small>
            <small> <Link to="" onClick={resetPassword}>Reset Password</Link> </small>
          </p>
          <div className="divider">OR</div>
          <button
            onClick={() => signInWithGoogle()}
            className="btn btn-outline"
          >
            Continue With Google
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
